<template>
    <div class="base-wrap ml-auto mr-auto" id="shop_cart">
        <div class="d-flex d-center-between border-bottom pb-4">
            <div class="d-start-start align-items-center">
                <h1>半山伴水-品牌馆</h1>
                <div class="ml-4">
                    <i class="iconfont text-login h4">&#xe660;</i>
                    <span class="text-muted cursor-pointer" @click="clearShop">（清空购物车）</span>
                </div>
            </div>
            <el-steps class="w-30" :space="500" :active='activeIndex' finish-status="success" align-center>
                <el-step title="提交订单" />
                <el-step title="等待确认" />
                <el-step title="订单支付" />
                <el-step title="订单完成" />
            </el-steps>
        </div>
        <div v-if="full">
            <brand-order :type="'room'" :content="room" @getPrice = "getPrice" />
            <brand-order :type="'meet'" :content="meet" @getPrice = "getPrice" />
            <brand-order :type="'restaurant'" :content="restaurant" @getPrice = "getPrice" />
            <brand-order :type="'acti'" :content="acti" @getPrice = "getPrice" />
            <brand-order :type="'itinerary'" :content="itinerary" @getPrice = "getPrice" />
            <div class="mt-4 mb-2 position-relative">
                <h2>备注</h2>
                <img v-if="StoreBasicInfo.seal" class="seal" v-lazy="ImgPreUrl+StoreBasicInfo.seal" :key="1">
            </div>
            <el-input class="w-85" type="textarea" :rows="4" placeholder="请输入备注" v-model="remarks" />
            <div class="total">
                <label>总计：<span class="text-info h4">&yen; {{rprice + mprice + eprice + aprice + iprice}}</span></label>
                <el-button class="bg-info" @click="StoreBasicInfo.seal ? submit() : showSeal = true" :disabled="disabled">提交订单</el-button>
            </div>
        </div>
        <div v-else class="text-center m-auto mt-5 mb-5">
            购物车空空如也，快去 <router-link to="/index_brand/brand_detail/3/tabRooms">添加</router-link> 吧
        </div>
        <el-dialog title="电子章" :visible.sync="showSeal" center>
            <div class="text-center text-danger">为保障双方权益，建议您下单时使用电子章</div>
            <div slot="footer" class="dialog-footer mb-3">
                <el-button size="small" class="mr-4" @click="submit">等会再说</el-button>
                <el-button size="small" type="primary" @click="$router.push({name:'StoreBasicInfo'})">现在去上传</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
  import {mapState,mapActions} from 'vuex'

import BrandOrder from './BrandOrder'

export default {
    name: 'BrandShopCart',
    components: {BrandOrder},
    data () {
        return {
            activeIndex: 0,
            room: [],
            copyRoom: [],
            meet: [],
            copyMeet: [],
            restaurant: [],
            copyRestaurant: [],
            acti: [],
            copyActi: [],
            itinerary: [],
            copyItinerary: [],
            remarks:'',
            full:true,
            rprice: 0,
            mprice: 0,
            eprice: 0,
            aprice: 0,
            iprice: 0,
            disabled: false,
            showSeal: false
        }
    },
    computed: {
        ...mapState(['StoreBasicInfo']),
    },
    created () {
        this.ArrClassify()
        this.getStoreInfo()
    },
    methods: {
        ...mapActions(['travelBrandSubmit','getStoreInfo']),
        ArrClassify () {
            this.$GFUN.classFiy(this.getArr('room'),'usetime').then(v => this.room = v)
            this.$GFUN.classFiy(this.getArr('meet'),'usetime').then(v => this.meet = v)
            this.$GFUN.classFiy(this.getArr('restaurant'),'usetime').then(v => this.restaurant = v)
            this.$GFUN.classFiy(this.getArr('acti'),'usetime').then(v => this.acti = v)
            this.$GFUN.classFiy(this.getArr('itinerary'),'usetime').then(v => this.itinerary = v)
        },
        getArr(keyname) {
            return JSON.parse(localStorage.getItem(keyname)) || []
        },
        clearShop () {
            this._confirm('确认清空购物车么？',() => {
                localStorage.removeItem('room')
                localStorage.removeItem('meet')
                localStorage.removeItem('restaurant')
                localStorage.removeItem('acti')
                localStorage.removeItem('itinerary')
                this.full = false
            })
        },
        getPrice (params,type) {
            if (type == 'room') this.rprice = params
            if (type == 'meet') this.mprice = params
            if (type == 'restaurant') this.eprice = params
            if (type == 'acti') this.aprice = params
            if (type == 'itinerary') this.iprice = params
        },
        validateForm(room,restaurant,acti,itinerary) {
            for (let i = 0; i < room.length; i++) {
                let item = room[i]
                if (!this.$GFUN.isPositiveInteger(item.num) || (item.num > item.totalNum)) {
                    return {code: false, msg:`${item.title}数量有误！`};
                }
            }
            for (let i = 0; i < restaurant.length; i++) {
                let item = restaurant[i]
                if (!this.$GFUN.isPositiveInteger(item.num) || (item.num < item.minNum)) {
                    return {code: false, msg:`${item.name}数量有误！`};
                }
            }
            for (let i = 0; i < acti.length; i++) {
                let item = acti[i]
                if (!this.$GFUN.isPositiveInteger(item.num)) {
                    return {code: false, msg:`${item.name}数量有误！`};
                }
            }
            for (let i = 0; i < itinerary.length; i++) {
                let item = itinerary[i]
                if (!this.$GFUN.isPositiveInteger(item.num)) {
                    return {code: false, msg:`${item.name}数量有误！`};
                }
            }
            return {code:true, msg:'验证通过'};
        },
        submit () {
            this.copyRoom = []; this.copyMeet = []; this.copyRestaurant = []; this.copyActi = []; this.copyItinerary = []
            this.circle('room','copyRoom'); this.circle('meet','copyMeet');this.circle('itinerary','copyItinerary')
            this.circle('restaurant','copyRestaurant'); this.circle('acti','copyActi');
            let result = this.validateForm(this.copyRoom,this.copyRestaurant,this.copyActi,this.copyItinerary);
            if (result.code) {
                this._confirm('确认提交订单么？',() => {
                    this.disabled = true
                    let room = this.copyRoom.map(v => {
                        return {room_id: v.id,num: v.num,time:new Date(v.usetime).getTime() / 1000,price:v.price}
                    })
                    let meeting = this.copyMeet.map(v => {
                        return {meeting_id: v.id,num:1,timeslot:v.retime.substr(-1),time:new Date(v.usetime).getTime() / 1000,price:v.price}
                    })
                    let restaurant = this.copyRestaurant.map(v => {
                        return {restaurant_id: v.id,num: v.num,timeslot:v.eatime,time:new Date(v.usetime).getTime() / 1000,price:v.price}
                    })
                    let onsale = this.copyActi.map(v => {
                        return {onsale_id: v.id,num:v.num,time:new Date(v.usetime).getTime() / 1000,price:v.price}
                    })
                    let itinerary = this.copyItinerary.map(v => {
                        return {itinerary_id: v.id,num:v.num,time:new Date(v.usetime).getTime() / 1000,price:v.price}
                    })
                    this.travelBrandSubmit({
                        data: {
                            brandhall_id: this.brandId,
                            room,meeting,restaurant,onsale,itinerary,
                            remark: this.remarks,
                        },
                        successFun: (res) => {
                            this._alert('提交成功',() => {
                                localStorage.removeItem('room')
                                localStorage.removeItem('meet')
                                localStorage.removeItem('restaurant')
                                localStorage.removeItem('acti')
                                localStorage.removeItem('itinerary')
                                this.$router.push({name:'OrderLists',query:{orderStatus:'14',orderType:8}})
                            })
                        }
                    })
                })
            } else this._alert(result.msg,null,'error');
        },
        circle (arr,copyArr) {
            this[arr].forEach(v => {
                v.arr.forEach(m => {
                    this[copyArr].push(m)
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.base-wrap{
    margin: 50px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    text-align: left;
    .total{
        margin-top: 45px;
        background-color: #f8f8f8;
        height: 70px;
        line-height: 70px;
        text-align: right
    }
    .bg-info{
        margin-left: 50px;
        margin-right: 20px;
        color: #fff;
        font-size: 14px;
        padding: 5px 10px;
        border-radius: 5px;
        cursor:pointer;
        border: 0!important
    }
    .is-disabled{
        background-color: #e5e5e5!important
    }
    .seal{
        width: 128px;
        position: absolute;
        right: 0;
        top: 0px;
    }
}
</style>